export default __webpack_public_path__ + "static/media/lasko_mobile_temna3.573a99fb.png";